import { MessageState } from './message.state';

export interface MessageContainerState {
  error: string;
  loading: boolean;
  message: MessageState;
}

export const initialMessageContainerState: MessageContainerState = {
  error: '',
  loading: false,
  message: null
};
